<template>
  <v-app class="app">
    <EcLoginForm />
  </v-app>
</template>

<script>
import EcLoginForm from './components/EcLoginForm.vue'
import baseAppFactory from '../common/baseAppFactory'

export default baseAppFactory({ EcLoginForm })
</script>

<style>
.v-application__wrap {
  min-height: fit-content !important;
}
</style>
